var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import Grid from '../../../components/UI/Grid/Grid';
var OptionValuesList = /** @class */ (function (_super) {
    __extends(OptionValuesList, _super);
    function OptionValuesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gridHeaders = [
            { name: 'Value', key: 'value', filter: false, sort: false },
        ];
        _this.editOptionValue = function (rowItem) {
            _this.props.edit(_.get(rowItem, 'id', '-1'));
        };
        _this.onPage = function (event) {
            _this.props.getAllOptionValues(event.page + 1);
        };
        return _this;
    }
    OptionValuesList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, lazy: true, total: _.get(meta, 'total_records', 0), rows: _.get(meta, 'per_page', 0), first: (_.get(meta, 'current_page', 0) - 1) * _.get(meta, 'per_page', 0), onPage: this.onPage, editAction: this.editOptionValue }));
    };
    return OptionValuesList;
}(React.Component));
// @ts-ignore
export default withRouter(OptionValuesList);



//////////////////
// WEBPACK FOOTER
// ./src/components/OptionValues/OptionValuesList/OptionValuesList.tsx
// module id = 384
// module chunks = 0